export type NavKey =
  | "applications"
  | "tenants"
  | "prices"
  | "catalogue"
  | "generations"
  | "screening"
  | "webhooks"
  | "reconciliation"
  | "runpod"
  | "audit";

/** The admin sidebar, in order, with the one job each screen answers. */
export const NAV: { key: NavKey; label: string; path: string; job: string }[] = [
  { key: "applications", label: "Applications", path: "/applications", job: "Partner applications waiting for review, with the answers they sent." },
  { key: "tenants", label: "Tenants", path: "/tenants", job: "Every partner account: status, balance, limits and keys." },
  { key: "prices", label: "Prices", path: "/prices", job: "The price list per effect and variant, and scheduled changes." },
  { key: "catalogue", label: "Catalogue", path: "/catalogue", job: "Effects, their variants and whether each is published." },
  { key: "generations", label: "Generations", path: "/generations", job: "Every job across tenants, searchable by ID." },
  { key: "screening", label: "Screening log", path: "/screening", job: "Input checks that rejected a photo, and why." },
  { key: "webhooks", label: "Webhook health", path: "/webhooks", job: "Delivery success per tenant endpoint, and endpoints that are failing." },
  { key: "reconciliation", label: "Reconciliation", path: "/reconciliation", job: "Top-up invoices the ledger and the payment provider disagree on." },
  { key: "runpod", label: "RunPod float", path: "/runpod", job: "The prepaid GPU balance and how many days it lasts at current spend." },
  { key: "audit", label: "Audit log", path: "/audit", job: "Every operator action, who took it and when." },
];
